import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { collections, documents } from "../../firebase/firestoreNameSpaces";
import Navbar from "../Navbar1/NavBar1";
import Footer from "../Footer/Footer";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import { firebase } from "../../firebase/index";
import classes from "./Auth.module.css"
class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      phone: "", 
      OTP: "",
      display: "d-none",
      coutryCode: "+91",
      loading: false,
      verifyBtnLoading: false,
    }; 
    this.handleChange = this.handleChange.bind(this);
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
    this.setUpCaptcha = this.setUpCaptcha.bind(this);
    this.onSignInSubmit = this.onSignInSubmit.bind(this);
    this.handleCodeSubmit = this.handleCodeSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this._next();
  };

  _next() {
    let phone = this.state.phone;
    if (phone.length !== 10) {
      this.setState({ display: "d-block" });
      setTimeout(() => {
        this.setState({
          display: "d-none",
        });
      }, 2000);
    } else {
      this.onSignInSubmit(this.state.coutryCode + phone);
    }
  }

  _prev() {
    let currentStep = this.state.currentStep;
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    this.setState({
      currentStep: currentStep,
    });
  }

  get previousButton() {
    let currentStep = this.state.currentStep;
    if (currentStep !== 1) {
      return (
        <button
          className="btn btn-secondary btn-sm mt-2"
          type="button"
          onClick={this._prev}
          disabled={this.state.verifyBtnLoading}
        >
          {this.state.verifyBtnLoading ? "Wait" : "Go Back"}
        </button>
      );
    }
    return null;
  }

  get nextButton() {
    let currentStep = this.state.currentStep;
    if (currentStep < 2) {
      return (
        <button
          className="btn btn-primary btn-sm "
          type="button"
          onClick={this._next}
          disabled={this.state.loading}
        >
          <span
            className="mobi-mbri mobi-mbri-right mbr-iconfont mbr-iconfont-btn"
            style={{ fontSize: "25px" }}
          ></span>
          {this.state.loading ? "Sending" : "Get OTP"}
        </button>
      );
    }
    return null;
  }
  setUpCaptcha = () => {
    this.setState({ loading: true });
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha",
      {
        size: "invisible",
        callback: function (response) {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // onSignInSubmit();
        },
      }
    );
  };
  onSignInSubmit = (phoneNumber) => {
    this.setState({ loading: true });
    // e.preventDefault();
    this.setUpCaptcha();

    var appVerifier = window.recaptchaVerifier;
    let _this = this;
    firebase
      .auth()
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(function (confirmationResult) {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        let currentStep = _this.state.currentStep;
        currentStep = currentStep >= 2 ? 3 : currentStep + 1;
        _this.setState({ phone: "", loading: false, currentStep: currentStep });
        window.confirmationResult = confirmationResult;
      })
      .catch(function (error) {
        // Error; SMS not sent
        // ...
        _this.setState({ loading: false });
        alert("Sms not sent try again");
        window.location.reload();
        // window.location.reload();
      });
  };
  handleCodeSubmit = () => {
    // e.preventDefault();
    this.setState({ verifyBtnLoading: true });
    let _this = this; 
    window.confirmationResult
      .confirm(this.state.OTP)
      .then(function (result) {
        // User signed in successfully.
        var user = result.user;

        let db = firebase.firestore();
        db.collection(collections.USERS)
          .doc(user.uid)
          .set(
            { userId: user.uid, phoneNumber: user.phoneNumber },
            { merge: true }
          )
          .then(() => {
            _this.setState({ verifyBtnLoading: false });
            _this.props.history.replace("/");
            // window.location = "https://localhost:3000"
          })
          .catch((err) => {
            firebase
              .auth()
              .signOut()
              .then()
              .catch((err) => console.log(err));
            return console.log(err);
          });
      })
      .catch(function (error) {
        _this.setState({ verifyBtnLoading: false });
        return alert("Invalid OTP, Please try again");
      });
  };

  render() {
    return ( 
      <React.Fragment>
        <Navbar />
      
       <Footer>
       <section className={classes.Section} id="form6-12" >
          <div className="container">
            <div className={`mbr-section-head text-center`}>
              <h3 className={`mbr-section-title mbr-fonts-style align-center mb-0 ${classes.Header}`} >
                <strong >Login/Register</strong>
              </h3>
            </div>
            <div className="row justify-content-center mt-4">
              <div className={`col-lg-8 mx-auto mbr-form`}>
                <form
                  onSubmit={this.handleSubmit}
                  className="mbr-form form-with-styler mx-auto"
                  data-form-title="Login/Register"
                >
                  <div className={`dragArea row ${classes.InnerSection} text-center`}>
                    <div id="recaptcha"></div>
                    <Step1
                      currentStep={this.state.currentStep}
                      handleChange={this.handleChange}
                      phone={this.state.phone}
                      display={this.state.display}
                    />
                    <Step2
                      currentStep={this.state.currentStep}
                      handleChange={this.handleChange}
                      OTP={this.state.OTP}
                      submitCode={this.handleCodeSubmit}
                    />
                  </div>
                  <div className="text-center mt-2" >
                  {this.previousButton}
                  {this.nextButton}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
       </Footer>
        
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    verifyBtnLoading: state.auth.verifyBtnLoading,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     addUser:(userId,phoneNumber)=>dispatch(actions.addUser(userId,phoneNumber))
//   };
// };

export default withRouter(
  connect(mapStateToProps, null)(Auth)
);
